/**
 * a simple class to generate a unique HTML element's Id.
 * using this simple solution: https://gist.github.com/gordonbrander/2230317
 * simple check for duplication but super doubtful there will be name collisions
 * unless you plan on using it for thousands of unique IDs on one page
 */
export default class {
	constructor(prefix = "uid-") {
		this.prefix = prefix;
	}

	generate() {
		let id = this.prefix + Math.random().toString(36).substr(2, 9);

		if (document.getElementById(id) !== null) {
			return this.generate(); // try again
		}
		return id;
	}
}
